import React from "react";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { currencyFormatNoDecimals } from "../../shared/shared";

const PercentageCellOneHundredStocksBondsCash = (props) => {
  const handleChange = (e) => {
    if (props.onChange) {
      props.onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: parseFloat(e.target.value * 100).toFixed(0),
      });
    }
  };
  const { dataItem } = props;
  const field = props.field || "";
  const dataValue = dataItem[field] === null ? "" : dataItem[field] / 100;

  if (!dataItem.inEdit) {
    return <td>
      {`${(dataValue * 100).toFixed(0)}%`}
    </td>
  }

  return (
    <td>
      <NumericTextBox
        label={" "}
        value={parseFloat(dataValue)}
        onChange={handleChange}
        format={"0%"}
        min={0}
        max={1}
        step={0.01}
        valid={(parseFloat(dataItem.bonds) + parseFloat(dataItem.cash) + parseFloat(dataItem.stocks)) === 100}
      />
    </td>
  );
};

export const AdvancedPercentageCell = (validationFn) => (props) => {
  const { dataItem } = props;
  const field = props.field || "";
  let format = "0%";
  let fixed = 0;
  if (
      field === 'upsideRate' ||
      field === 'downsideRate' ||
      field === 'stackingMultiplier' ||
      field === 'benefitBaseBonus' ||
      field === 'payoutFactors'
  ) {
    format = "0.00%";
    fixed = 2;
  }
  const dataValue = dataItem[field] === null ? "" : dataItem[field] / 100;

  const handleChange = (e) => {
    if (props.onChange) {
      props.onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: parseFloat(e.target.value * 100).toFixed(fixed),
      });
    }
  };

  if (!dataItem.inEdit) {
    return <td>
      {`${(dataValue * 100).toFixed(fixed)}%`}
    </td>
  }

  return (
      <td>
        <NumericTextBox
            label={" "}
            value={dataValue}
            onChange={handleChange}
            format={format}
            step={0.001}
            valid={validationFn(props.dataItem)}
        />
      </td>
  );

}

const PercentageCell = (props) => {
  const { dataItem } = props;
  const field = props.field || "";
  let max = 1;
  let format = "0%";
  let fixed = 0;
  if (field === 'increasingGrowthMultiplier' || field === 'stackingMultiplier') {
    max = 5;
  } else if (field === 'payoutCola') {
    max = 0.05;
  }
  if (
      field === 'cashValueReturn' ||
      field === 'premiumBonus' ||
      field === 'hypotheticalIndexReturn' ||
      field === 'baseRollUpRate' ||
      field === 'stackingMultiplier' ||
      field === 'benefitBaseBonus' ||
      field === 'increasingGrowthMultiplier' ||
      field === 'payoutFactors' ||
      field === 'payoutCola' ||
      field === 'deathBenefitReturn'
  ) {
    format = "0.00%";
    fixed = 2;
  }
  const dataValue = dataItem[field] === null ? "" : dataItem[field] / 100;

  const handleChange = (e) => {
    if (props.onChange) {
      props.onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: parseFloat(e.target.value * 100).toFixed(fixed),
      });
    }
  };

  if (!dataItem.inEdit) {
    return <td>
      {`${(dataValue * 100).toFixed(fixed)}%`}
    </td>
  }

  return (
    <td>
      <NumericTextBox
        label={" "}
        value={dataValue}
        onChange={handleChange}
        format={format}
        min={0}
        max={max}
        step={0.001}
      />
    </td>
  );
};

export {
  PercentageCell,
  PercentageCellOneHundredStocksBondsCash,
};
